import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { Regions } from "@/types/base";

interface SearchHistoryState {
  searchHistory: Regions[];
  setSearchHistory: (layer: Regions) => void;
}

export const useSearchHistory = create<SearchHistoryState>()(
  persist(
    (set) => ({
      searchHistory: [],
      setSearchHistory: (region) =>
        set((state) => {
          const filteredHistory = state.searchHistory.filter(
            (item) => item.hexgroup_id !== region.hexgroup_id
          );

          return {
            searchHistory: [region, ...filteredHistory],
          };
        }),
    }),
    {
      name: "city-search-history",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
